const sideMenuData = [
    {
        name: 'BATTLEFIELD V',
        tag: 'BF_V'
    },
    {
        name: 'BATTLEFIELD 1',
        tag: 'BF_1'
    },
    {
        name: 'BATTLEFIELD 4',
        tag: 'BF_4'
    },
    {
        name: 'BATTLEFIELD HARDLINE',
        tag: 'BF_Hardline'
    },
    {
        name: 'CAREER',
        tag: 'career'
    },
    {
        name: 'WATCH',
        tag: 'watch'
    },
    {
        name: 'NEWS',   
        tag: 'news'
    }
];

export default sideMenuData;